import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client';
import { useMemo } from 'react';
import { GET_STORES_FOR_CATEGORY_PRODUCTS } from 'mocks/queries';
import useUserLocation from 'global-state/userLocation/useUserLocation';

// Limit to top 5 closest stores not to clutter up the modal
const MAX_STORES_PER_PRODUCT = 5;
const useProductStoresForCategory = t0 => {
  const $ = _c(19);
  const {
    categorySlug,
    skip: t1
  } = t0;
  const skip = t1 === undefined ? false : t1;
  const userLocation = useUserLocation();
  const zipCode = userLocation?.zip ?? "";
  let t2;
  if ($[0] !== categorySlug || $[1] !== zipCode) {
    t2 = {
      categorySlug,
      zipCode,
      limit: MAX_STORES_PER_PRODUCT
    };
    $[0] = categorySlug;
    $[1] = zipCode;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = skip || !zipCode || !categorySlug;
  let t4;
  if ($[3] !== t2 || $[4] !== t3) {
    t4 = {
      variables: t2,
      skip: t3
    };
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const {
    data,
    loading,
    error
  } = useQuery(GET_STORES_FOR_CATEGORY_PRODUCTS, t4);
  let t5;
  bb0: {
    if (!data?.getStoresForCategoryProducts) {
      let t6;
      if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = {
          storesLookup: {},
          productStoresMap: {},
          productDistancesMap: {}
        };
        $[6] = t6;
      } else {
        t6 = $[6];
      }
      t5 = t6;
      break bb0;
    }
    const {
      stores,
      productStores
    } = data.getStoresForCategoryProducts;
    let t6;
    if ($[7] !== stores) {
      t6 = stores.reduce(_temp, {});
      $[7] = stores;
      $[8] = t6;
    } else {
      t6 = $[8];
    }
    const storesLookup = t6;
    let t7;
    if ($[9] !== productStores) {
      t7 = productStores.reduce(_temp2, {
        productStoresMap: {},
        productDistancesMap: {}
      });
      $[9] = productStores;
      $[10] = t7;
    } else {
      t7 = $[10];
    }
    const {
      productStoresMap,
      productDistancesMap
    } = t7;
    let t8;
    if ($[11] !== productDistancesMap || $[12] !== productStoresMap || $[13] !== storesLookup) {
      t8 = {
        storesLookup,
        productStoresMap,
        productDistancesMap
      };
      $[11] = productDistancesMap;
      $[12] = productStoresMap;
      $[13] = storesLookup;
      $[14] = t8;
    } else {
      t8 = $[14];
    }
    t5 = t8;
  }
  const storesData = t5;
  let t6;
  if ($[15] !== error || $[16] !== loading || $[17] !== storesData) {
    t6 = {
      ...storesData,
      loading,
      error
    };
    $[15] = error;
    $[16] = loading;
    $[17] = storesData;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
};
export default useProductStoresForCategory;
function _temp(acc, store) {
  acc[store.id] = store;
  return acc;
}
function _temp2(acc_0, t0) {
  const {
    productId,
    storeIds,
    distances
  } = t0;
  acc_0.productStoresMap[productId] = storeIds;
  acc_0.productDistancesMap[productId] = distances;
  return acc_0;
}